import React, { useEffect, useMemo } from 'react';
import moment from 'moment';
import { LoadingIcon, Accordion } from '@prosolve/common-components-ui'
import styled from 'styled-components';
import useDataSessions from '../../../dataHooks/useDataSessions';
import useCustomEventListener from '../../../hooks/useCustomEventListener';
import { useNavigate } from "react-router-dom";

const SessionBlock = styled.div`
  display: flex;
  background: #F3FBFF;
  color: #565656;
  padding: 7px 10px 7px 7px;
  border: 1px solid #c4c4c4;
  border-radius: 5px;
  font-size: 16px;
  word-wrap: break-word;
`;

export default ({
  eventData = {},
  onSessionsChange,
  suppressTitle
}) => {

  const {
    isLoading,
    sessions,
    fetchSessions
  } = useDataSessions();

  useEffect(() => {
    if (onSessionsChange) {
      onSessionsChange(sessions)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessions]) 

  const sessionsByDayMap = useMemo(() => {
    const sMap = {};
    sessions.forEach((session) => {
      const { date } = session;
      if (!sMap[date]) {
        sMap[date] = [];
      }
      sMap[date].push(session)
    })

    // Next we go ahead and sort each of the date arrays for effeciency
    Object.keys(sMap).forEach(key => {
      sMap[key].sort(({ startTime: startTimeA }, { startTime: startTimeB }) => moment(startTimeA, 'hh:mm:ss') - moment(startTimeB, 'hh:mm:ss'))
    });

    return sMap;
  }, [sessions]);

  useEffect(() => {
    fetchSessions({ eventId : eventData.id })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventData.id])

  useCustomEventListener('reloadSessions', () => fetchSessions({ eventId : eventData.id }));

  const getDateHeaderBlock = (date, index) => {
    const displayDate = moment(date, 'YYYY-MM-DD').format('ddd, MM/DD/YY');
    return (
      <div>
        <div style={{ display: 'flex', alignItems: 'center', color: '#565656', fontSize: '14px' }}>
          <div>{`Day ${index + 1}`}</div>
          <div style={{ padding: '0px 5px' }}>{`-`}</div>
          <div>{`${sessionsByDayMap[date].length} Sessions`}</div>
        </div>
        <div style={{ fontWeight: 'bold', marginTop: '5px', color: '#565656', fontSize: '15px' }}>{displayDate}</div>
      </div>
    )
  }

  const formatSessionsTimes = (startTime, endTime) => {
    const start = moment(startTime, 'hh:mm:ss').format('h:mm A');
    const end = moment(endTime, 'hh:mm:ss').format('h:mm A');
    return `${start} - ${end}`;
  }

  const navigate = useNavigate();

  const onClickSessionLink = (session = {}) => {
    navigate(`session?id=${session._id}`);
  }

  const {
    timeZone
  } = eventData

  return (
    <div 
      style={{ 
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <div style={{
        color: '#565656',
        padding: '20px',
        paddingTop: '0px',
        borderBottom: '1px solid #C2C9D1'
      }}>
        { !suppressTitle &&
          <div style={{
            fontSize: '17px',
            fontWeight: 'bold',
          }}>
            {'Schedule'}
          </div>
        }
        {
          Boolean(timeZone) &&
          <div style={{ fontSize: '13px', marginTop: '10px' }}>
            {`All times are in the ${timeZone} time zone`}
          </div>
        }
      </div>
        {
        isLoading ?
          <div style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '20px'
          }}>
            <LoadingIcon />
          </div>
          :
          <div style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            padding: '10px'
          }}>
            {
              Object.keys(sessionsByDayMap).length > 0
              ?
              Object.keys(sessionsByDayMap)
              .sort((a, b) => moment(a, 'YYYY-MM-DD') - moment(b, 'YYYY-MM-DD'))
              .map((date, index) => {

                const sessionsInDay = sessionsByDayMap[date]

                return (
                  <Accordion
                    key={date}
                    title={getDateHeaderBlock(date, index)}
                    defaultOpen={index === 0}
                    headerExpands={true}
                    style={{ padding: '20px 5px 20px 5px' }}
                    expandedStyle={{ padding: '0px 0px 10px 0px' }}
                  >
                    <div style={{
                      flex: 1,
                      display: 'flex',
                      flexDirection: 'column',
                      rowGap: '10px',
                    }}>
                      {
                        sessionsInDay.map((session) => {
                          const {
                            _id,
                            name,
                            startTime, 
                            endTime
                          } = session
                          return (
                            <SessionBlock key={_id}>
                              <div style={{ background: '#0280c6', width: '3px' }}>
                                &nbsp;
                              </div>
                              <div style={{ flex: 1, padding: '3px 10px' }}>
                                <div style={{ fontSize: '14px' }}>{formatSessionsTimes(startTime, endTime)}</div>
                                <div 
                                  style={{ display: 'inline-flex', marginTop: '5px', color: '#0280c6', textDecoration: 'underline', cursor: 'pointer' }}
                                  onClick={() => onClickSessionLink(session)}
                                >
                                  {name}
                                </div>
                              </div>
                            </SessionBlock>
                          )
                        })
                      }
                    </div>
                  </Accordion>
                )
              })
              :
              <div style={{
                color: '#565656',
                fontSize: '14px',
                padding: '10px'
              }}>
                {'No sessions found'}
              </div>
            }
          </div>
      }
    </div>
  )
}